import { RichText } from "@payloadcms/richtext-lexical/react";
import { StepOptionsGroup } from "./StepOptionsGroup";
import styles from './StepsAccordion.module.css';
import React from "react";

function hasInlineBlock(node: any): boolean {
  if (!node) return false;
  if (Array.isArray(node)) return node.some(hasInlineBlock);
  if (node.type === "inlineBlock" && node.fields?.blockType === "listWithImageBlock") return true;
  if (node.children) return hasInlineBlock(node.children);
  return false;
}

function renderLexicalChildren(children: any[]) {
  return children.map((child, idx) => {
    if (child.type === "text") {
      const isBold = (child.format & 1) === 1;
      return (
        <span
          key={idx}
          className={isBold ? "font-bold" : ""}
        >
          {child.text}
        </span>
      );
    }

    if (child.type === "linebreak") {
      return <span key={idx} dangerouslySetInnerHTML={{ __html: "<br>" }} />;
    }

    if (child.type === "inlineBlock" && child.fields?.blockType === "listWithImageBlock") {
      return <StepOptionsGroup key={idx} fields={child.fields} />;
    }

    return null;
  });
}
const headingClassMap: Record<string, string> = {
  h1: styles.h1,
  h2: styles.h2,
  h3: styles.h3,
  h4: styles.h4,
  h5: styles.h5,
  h6: styles.h6,
};
export function RichTextRenderer({ content }: { content: any }) {
  const hasCustomBlock = hasInlineBlock(content?.root?.children);

  if (!hasCustomBlock) {
    return <RichText data={content} />;
  }

  return (
    <div>
      {(content?.root?.children ?? []).map((block: any, idx: number) => {
        if (block.type === "paragraph") {
          const onlyInlineBlock =
            block.children?.length === 1 && block.children[0].type === "inlineBlock";
          if (onlyInlineBlock && block.children[0].fields?.blockType === "listWithImageBlock") {
            return <StepOptionsGroup key={idx} fields={block.children[0].fields} />;
          }

          return (
            <div key={idx} className="">
              {renderLexicalChildren(block.children)}
            </div>
          );
        }

        if (block.type === "heading" && block.tag) {
          const Tag = block.tag as keyof React.JSX.IntrinsicElements;

          const headingClass = headingClassMap[block.tag] || "";

          return (
              <Tag key={idx} className={headingClass + ""}>
                {renderLexicalChildren(block.children)}
              </Tag>
          );
        }

        return null;
      })}
    </div>
  );
}
